module.exports = __webpack_public_path__ + "c0b61f521130f3f2670837dd4b1cfc64.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/the-economist.png
// module id = iThx
// module chunks = 0